import { RootPage } from '../page';
import $api from '../../api';
import * as siteConfig from '../../site-config/config';
import { ContextHelpModel } from '../../models/Gen/BaseModels';
import languages from '../../utils/languages';
//import createUUID from '../../utils/uuid';

import HelpEditor from './components/helpEditor';
import EditorIframePositionBar from '../../components/editor/editorIframePositionBar';
import EditorSettingsComponent from '../../components/editor/editorSettings';
import BackdropDescriptor from '../../components/descriptors/backdropDescriptor';
import PositionValue from '../../components/descriptors/positionValue';
import IconSizingValue from '../../components/descriptors/iconSizingValue';

import EditorSettings from '../../models/EditorSettings';

import Switcher from '../../components/switcher';

import templates from '../../common/card-editor/templates';
import createUUID from '../../utils/uuid';
import { isFlagOn } from '../../utils/flags';

class ContextHelpEditorView extends RootPage {
    constructor() {
        super();

        this.isLoaded = ko.observable(false);

        this.isDirty = ko.observable();

        Switcher();

        const saveButtonState = ko.pureComputed(() => {
            return 'btn btn-success ' + (this.isDirty() ? ' btn-dot' : '');
        });

        const getProperSaveButtons = () => {
            if (!window.auth.isImpVo) {
                if (isFlagOn('editor_new_save')) {
                    return {
                        css: saveButtonState, onclick: () => { this.save() }, text: 'Save', subActions: [
                            { text: 'Save & Publish changes', onclick: this.saveAndPublish.bind(this), icon: 'fas fa-paper-plane' },
                            { text: 'Save & Close editor', onclick: this.saveAndClose.bind(this), icon: 'fas fa-sign-out-alt' },
                        ]
                    }
                } else {
                    return { css: 'btn btn-success', onclick: this.saveAndClose.bind(this), text: 'Save & Close' }
                }
            } else {
                return null
            }
        }

        window.topToolbarButtons = [
            /*{ css: 'btn btn-success', onclick: this.save.bind(this), text: 'Save & Close' }*/ getProperSaveButtons(),
            { css: 'btn fas fa-cog text-white mr-2', onclick: this.toggleSettings.bind(this), title: 'Settings' },
            { css: 'btn fas fa-question text-white mr-0', onclick: this.showHelp.bind(this, 'editor_hints'), title: 'Help' },
            { css: 'btn fas fa-eye text-white ' + (isFlagOn('editor_new_save') ? 'mr-5' : 'mr-4'), onclick: this.preview.bind(this), title: 'Preview' },
        ];

        HelpEditor(this);

        EditorIframePositionBar(this);
        EditorSettingsComponent(this);

        BackdropDescriptor(this);
        PositionValue(this);
        IconSizingValue(this);

        this.isMinimized = ko.observable(false);
        this.selectedHelp = ko.observable(null);
        this.contextHelp = ko.observable();

        window.addEventListener('message', (msg) => {
            if (msg.data.action === 'elementSelected') {
                document.dispatchEvent(new CustomEvent('cardElementQueried', { detail: { cardId: msg.data.cardId, query: msg.data.query, url: msg.data.url, iframe: msg.data.iframe } }));
                this.autosave();
            } else if (msg.data.action === 'saveCardContent') {
                document.dispatchEvent(new CustomEvent('cardContentSet', { detail: { cardId: msg.data.cardId, content: msg.data.content } }));
                this.autosave();
            } else if (msg.data.action === 'closeCard') {
                document.dispatchEvent(new CustomEvent('deselectCard', { detail: { cardId: msg.data.cardId } }));
            } else if (msg.data.action === 'relocateCard') {
                document.dispatchEvent(new CustomEvent('relocateCard', { detail: { cardId: msg.data.cardId } }));
            } else if (msg.data.action === 'add_card_template') {
                this.addNew({ type: msg.data.type, templateType: msg.data.templateType });
            } else if (msg.data.action === 'resume-card-editing') {
                document.dispatchEvent(new CustomEvent('cardResumeEditing', { detail: { cardId: msg.data.cardId } }))
            } else if (msg.data.action === 'elementSelectorChanged') {
                document.dispatchEvent(new CustomEvent('cardSelectorChanged', { detail: { cardId: msg.data.cardId, query: msg.data.query } }));
                this.autosave();
            }
        });

        window.onerror = (e) => {
            this.logSaveThanSorry();
        }

        this.settingsShown = ko.observable(false);
        this.editorSettings = new EditorSettings();

        this.supportedLanguages = this.supportedLanguages = window.auth.project.SupportedLanguages.map(lng => {
            return languages.filter(i => i.alpha2 == lng)[0];
        });//languages.filter(i => window.auth.project.SupportedLanguages.indexOf(i.alpha2) !== -1);
        this.selectedLanguage = ko.observable(window.auth.project.SupportedLanguages[0]);
        this.selectedLanguage.subscribe(lng => {
            window.parent.postMessage({ action: 'changeLanguage', language: this.selectedLanguage() }, '*');
        });

        this.isInDefaultLanguage = ko.pureComputed(() => {
            return this.selectedLanguage() == this.supportedLanguages[0].alpha2;
        });
    }

    onInit() {
        siteConfig.ContextHelpDescriptor.prototype._ModelExtender = function (model, p, pp, mappingOptions) {
            mappingOptions.cardPosition = {
                create: function (options) {
                    return new siteConfig.PositionValue(options.data);
                }
            };
            mappingOptions.iconPosition = {
                create: function (options) {
                    return new siteConfig.PositionValue(options.data);
                }
            };
            mappingOptions.iconSizing = {
                create: function (options) {
                    return new siteConfig.IconSizingValue(options.data);
                }
            };
            mappingOptions.backdrop = {
                create: function (options) {
                    return new siteConfig.BackdropDescriptor(options.data);
                }
            };
        }

        ContextHelpModel.prototype._ModelExtender = function (model, p, pp, mappingOptions) {
            mappingOptions.descriptorObject = {
                create: function (options) {
                    return new siteConfig.ContextHelpsGroupDescriptor(options.data);
                }
            };
        };

        var contextHelpAutosave = sessionStorage.getItem('contextHelpAutosave');

        if (contextHelpAutosave) {
            this.contextHelp(new ContextHelpModel(JSON.parse(contextHelpAutosave)));
        } else {
            this.contextHelp(new ContextHelpModel(this.getServerSideData('contextHelp')));
        }

        this.isLoaded(true);

        this.showWelcomeModalIfNeeded();
    }

    showWelcomeModalIfNeeded() {
        try {
            if (window.auth && window.auth.user && window.auth.user.SignUpAt >= '2022-01-19') {
                const welcomeShown = localStorage.getItem('pf_editor_hints_welcome_dialog_shown');

                if (!welcomeShown) {
                    $api.users.getSettings(
                        { key: 'hints_welcome_shown' },
                        {},
                        (val) => {
                            if (!val || Object.keys(val).length === 0) {
                                $api.users.setSettings(
                                    {},
                                    { key: 'hints_welcome_shown', value: '1' },
                                    () => {
                                    }
                                );

                                this.showHelp('hints-welcome');
                            }

                            localStorage.setItem('pf_editor_hints_welcome_dialog_shown', '1');
                        }
                    );
                }
            }
        } catch (e) {
            console.log('Welcome dialog err', e);
        }
    }

    preview() {
        window.parent.postMessage({ action: 'preview-helps', descriptor: JSON.stringify(ko.toJS(this.getDescriptor())) }, '*');
    }

    setSelectedHelp(help) {
        this.selectedHelp(help);
    }

    deselectCard() {
        this.autosave();
        document.dispatchEvent(new CustomEvent('closeCard', { detail: { cardId: ko.toJS(this.selectedHelp().help.id) } }));
        document.dispatchEvent(new CustomEvent('deselectCard', { detail: { cardId: ko.toJS(this.selectedHelp().help.id) } }));
    }

    removeCard(card) {
        var index = this.getDescriptor().helps.indexOf(card);
        if (index !== -1) {
            this.getDescriptor().helps.splice(index, 1);
        }
        this.autosave();
    }

    duplicateCard(card) {
        const newCard = new siteConfig.ContextHelpDescriptor(ko.mapping.toJS(card));
        newCard.id(createUUID());
        this.getDescriptor().helps.push(newCard);
        this.autosave();
    }

    saveAndPublish() {
        this.save(() => {
            $api.contextHelp.publish(
                { projectCode: auth.project.UniqueCode, id: this.contextHelp().id() },
                {},
                resp => {

                }
            );
        });
    }

    saveAndClose() {
        this.save(() => {
            window.parent.close();
        });
    }

    save(saved, error) {
        $api.contextHelp.save(
            { projectCode: auth.project.UniqueCode, id: this.contextHelp().id() },
            ko.mapping.toJS(this.contextHelp()),
            (resp) => {
                this.isDirty(false);

                if (saved) saved();
                //window.parent.close();
            },
            (err) => {
                if (error) error(err);
                this.logSaveThanSorry();
            },
            (err) => {
                if (error) error(err);
                this.logSaveThanSorry();
            }
        );
    }

    autosave() {
        //sessionStorage.setItem('contextHelpAutosave', JSON.stringify(this.contextHelp().toJS()));

        const objToSave = JSON.stringify(this.contextHelp().toJS(), (k, v) => (k === '__ko_mapping__' || k === '_ModelExtender' || k === 'toJS') ? undefined : v);

        try {
            const oldSavedObj = sessionStorage.getItem('contextHelpAutosave');
            requestAnimationFrame(() => {
                if (!!oldSavedObj && oldSavedObj != objToSave) {
                    document.dispatchEvent(new Event('pfruits_editor_dirty'));
                    this.isDirty(true);
                }
            });

            sessionStorage.setItem('contextHelpAutosave', objToSave);
        } catch (e) {
            this.logSaveThanSorry();
            alert('We have encountered an error while autosaving. Save your work by clicking on the Save and exit and open the editor again.');
        }
    }

    getDescriptor() {
        return this.contextHelp().descriptorObject();
    }

    addFromTemplate() {
        window.parent.postMessage({ action: 'pf_show_template_selector', type: 'hints' }, '*');
    }

    addNew(config) {
        var descriptor = this.getDescriptor();
        const template = templates[config.templateType];

        if (descriptor.helps() === null) {
            descriptor.helps([]);
        }

        var newHelp = new siteConfig.ContextHelpDescriptor();

        newHelp.name('Help #' + (descriptor.helps().length + 1));
        newHelp.targetUrl(new siteConfig.StringValue());

        newHelp.trigger({ type: 'onload' });

        var backdrop = new siteConfig.BackdropDescriptor();
        backdrop.type('blocking');
        newHelp.backdrop(backdrop);

        var content = new siteConfig.ContextHelpContentDescriptor();
        //content.title(titleContent);
        //content.footer(footerContent);

        if (template) {
            content.body(template.body);
        } else {
            content.body(generateDefaultRowForSupportedLanguages('Describe the element here.'));
        }

        newHelp.content(content);

        if (template && template.footer) {
            var footer = new siteConfig.ContextHelpCardFooterDescriptor();

            footer.visible(template.footer.visible);

            content.footer(footer);
        } else {
            var footer = new siteConfig.ContextHelpCardFooterDescriptor();

            footer.visible(false);

            const closeButton = new siteConfig.ButtonInputDescriptor();
            closeButton.text(generateTextForSupportedLanguages('Close'));
            closeButton.visible(true);
            footer.closeButton(closeButton);

            const dismissButton = new siteConfig.ButtonInputDescriptor();
            dismissButton.text(generateTextForSupportedLanguages('Dismiss forever'));
            dismissButton.visible(true);
            footer.dismissButton(dismissButton);

            content.footer(footer);
        }

        const cardPosition = new siteConfig.PositionValue();
        cardPosition.width('320px');
        newHelp.cardPosition(cardPosition);

        descriptor.helps.push(newHelp);

        this.autosave();

        function generateTextForSupportedLanguages(text) {
            let lngObj = {};
            for (const lng of window.auth.project.SupportedLanguages) {
                lngObj[lng] = text;
            }
            return lngObj;
        }

        function generateDefaultRowForSupportedLanguages(text) {
            let lngObj = {};
            for (const lng of window.auth.project.SupportedLanguages) {
                lngObj[lng] = [{
                    row: 0,
                    text: {
                        [lng]: text
                    }
                }];
            }
            return lngObj;
        }
    }

    highlightAll() {
        window.parent.postMessage({ action: 'highlightAll', helps: this.getDescriptor().helps() }, '*');
    }

    toggleSettings() {
        if (this.settingsShown()) {
            this.editorSettings.saveToLocalStorage();
        }
        this.settingsShown(!this.settingsShown());
    }

    hideSettings() {
        this.settingsShown(false);
    }

    logSaveThanSorry() {
        const objToSave = JSON.stringify(this.contextHelp().toJS(), (k, v) => (k === '__ko_mapping__' || k === '_ModelExtender' || k === 'toJS') ? undefined : v);

        let tId = null;
        try {
            tId = this.contextHelp().id();
        } catch (e) {

        }

        $api.projects.autosaveThing(
            { projectCode: auth.project.UniqueCode },
            { ref: window.location.href, contextHelpId: tId, content: objToSave },
            () => { }
        );
    }

    showHelp(id) {
        window.parent.postMessage({
            action: 'pf_show_help',
            id
        }, '*');
    }

    copyContentFromBaseLanguage() {
        if (confirm('Do you really want to copy all content from the default language to the selected language? The content will be overwritten.')) {
            window.parent.postMessage({ action: 'copy_content', defaultLanguage: this.supportedLanguages[0].alpha2, targetLanguage: this.selectedLanguage() }, '*');
        }
    }
}

export default ContextHelpEditorView;